/* eslint-disable @next/next/no-img-element */
// libraries
import Slider from '@mui/material/Slider';
import dynamic from 'next/dynamic';
import Image from 'next/image';
import Link from 'next/link';
import React, { useCallback, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { allCaracteristicas, allDatasEntrega, categorias, district, get_estados } from '../../../services/selectors';
import { ensureReadableTextColor, formatCaracteristicas, formatSelects, formatSelectsEstados, formatSelectsTransacao, isColorLight, removerAcentos, toPrice } from '../../../utils/FunctionsGlobals';
import {
    getImoveisListCategoryStorageKey,
    getImoveisListCaracteristicasStorageKey,
    getImoveisListDatasStorageKey,
    getImoveisListStatesStorageKey,
    readJsonStorageValue,
} from '../../../utils/homeCache';
import { getWithTTL, setWithTTL } from '../../../utils/storage';
import { appendCodsiteQuery } from '../../../utils/url';
import { useAuth } from '../../context/Info';
import DrawerComponent from '../../drawer/DrawerComponent';
import { motion } from '../../utils/lightMotion';
import Mocks from './WelcomePieces.mocks';
import styles from './WelcomePieces.module.css';
const Select = dynamic(() => import('react-select'), { ssr: false });

// interface
interface ISelectors {
    allCities: Array<{ label: string; value: string; id_estado: any }>;
    allTypes: any;
    allTransacao: Array<{ label: string; value: string }>;
    allCompany: Array<{ label: string; value: string }>;
    site: any;
    urlBanner: string;
    companyInputActual: any;
    setCompanyInputActual: any;
    setActiveDrawer: any;
    activeDrawer: any;
    origin?: any;
    codsite?: any;
    favorito: Array<number>;
    valores?: any;
    codsite2?: any;
    isMobile1?: Boolean;
    props: any;
    allCards: any;
}

const WelcomePieces: React.FC<ISelectors> = ({
    allCities,
    allTypes,
    allCompany,
    allTransacao,
    site,
    urlBanner,
    companyInputActual,
    setCompanyInputActual,
    setActiveDrawer,
    activeDrawer,
    origin,
    codsite,
    favorito,
    valores,
    codsite2,
    isMobile1,
    props,
    allCards
}) => {
    // constants
    const {
        listCategory,
        setListCategory,
        listEstados,
        setListEstados,
        listCaracteristicas,
        setListCaracteristicas,
        listDatas,
        setListDatas
    } = useAuth();
    const colorPicker = Mocks.customSelectStyles(isColorLight(site?.cor12) ? site?.cor11 : site?.cor13);
    const searchButtonBackground = site?.cor2 || '#1e1e1e';
    const searchButtonPreferredTextColor = isColorLight(site?.cor2) ? site?.cor11 : site?.cor13;
    const searchButtonTextColor = ensureReadableTextColor(searchButtonPreferredTextColor, searchButtonBackground);
    const isSite2504 = Number(site?.id) === 2504;
    const isSite2507 = Number(site?.id) === 2507;
    const isSite2523 = Number(site?.id) === 2523;
    const showHomeCategoria = Boolean(site?.categoria_home) && !isSite2507;
    const showHomeCaracteristicas = Boolean(site?.caracteristicas_home) && !isSite2507;
    const showHomeDormitorios = true;
    const primarySearchFieldsCount2507 = site?.transacoes?.length > 1 ? 4 : 3;
    const primarySearchGap2507 = 12;
    const primarySearchFieldStyle2507 = isSite2507
        ? { width: `calc((100% - ${(primarySearchFieldsCount2507 - 1) * primarySearchGap2507}px) / ${primarySearchFieldsCount2507})` }
        : {};
    const hasDataEntrega2507 = Boolean(site?.mostrar_data_entrega && listDatas?.length > 0);
    const advancedFieldStyle2507 = primarySearchFieldStyle2507;
    const advancedFirstFieldStyle2507 = isSite2507 && primarySearchFieldsCount2507 === 4 && !hasDataEntrega2507
        ? {
            ...primarySearchFieldStyle2507,
            marginLeft: `calc((100% - ${(primarySearchFieldsCount2507 - 1) * primarySearchGap2507}px) / ${primarySearchFieldsCount2507} + ${primarySearchGap2507}px)`
        }
        : primarySearchFieldStyle2507;
    function valuetext(value: number) {
        return `${value}°C`;
    }
    const allOptions = [{label: '1', value: 1},{label: '2', value: 2},{label: '3', value: 3},{label: '4', value: 4},{label: '5 +', value: 5}];
    const [allDistrict, setAllDistrict] = useState([]);
    const [allCitiesAux, setAllCitiesAux] = useState(site?.id == 2065 ? allCities.filter(city => city?.id_estado == 24) : site?.id == 2297 || site?.id == 1942 ? allCities.filter(city => city?.id_estado == 23) : allCities);
    const [searchAdvanced, setSearchAdvanced] = useState(site?.id == "1667" || site?.id == "2366" || site?.id == "2118" || site?.id == "278" ? 1 : 0);
    const shouldHideHeaderText = Boolean(searchAdvanced && !isSite2523);
    const [citiesActual, setCitiesActual] = useState<any>(null);
    const [districtActual, setDistrictActual] = useState<Array<{label: string, value: number}>>([]);
    const [typesActual, setTypesActual] = useState<Array<{label: string, value: number}>>([]);
    const [caractActual, setCaractActual] = useState<Array<{label: string, value: number}>>([]);
    const [dataEntregaActual, setDataEntregaActual] = useState<Array<{label: string, value: number}>>([]);
    const [categoryActual, setCategoryActual] = useState<any>([]);
    const [estadoActual, setEstadoActual] = useState<any>(site?.id == 2065 ? {label: 'Santa Catarina', value: 24} : site?.id == 2297 || site?.id == 1942 ? {label: 'Rio Grande do Sul', value: 23} : {value: 0});
    const [urlTipo, setUrlTipo] = useState<string>("");
    const [urlCaract, setUrlCaract] = useState<string>("");
    const [urlDatas, setUrlDatas] = useState<string>("");
    const [urlDistrict, setUrlDistrict] = useState<string>("");
    const [transacaoActual, setTransacaoActual] = useState<any>(
    site?.id == 2470 || Number(site?.id) === 2523 ? null : allTransacao[0]
);
    const [dormitoriosActual, setDormitoriosAtual] = useState<any>();
    const [banheirosActual, setBanheirosAtual] = useState<any>();
    const [suitesActual, setSuitesAtual] = useState<any>();
    const [vagasActual, setVagasAtual] = useState<any>();
    const [codeActual, setCodeActual] = useState('');
    const [companyActual, setCompanyActual] = useState<any>(null);
    const [buscaAvan, setBuscaAvan] = useState<boolean>(false);
    const bannerSrc = urlBanner && urlBanner !== "undefined" ? urlBanner.replaceAll('"', "") : "";
    const isMobileView = Boolean(isMobile || isMobile1);
    const use2523MobileDefaultLayout = isSite2523 && isMobileView;
    const storageHost = site?.site || (typeof window !== 'undefined' ? window.location.host : '');
    const storageCodsite = codsite || site?.id || 0;
    const listCategoryStorageKey = getImoveisListCategoryStorageKey(storageHost, storageCodsite);
    const listStatesStorageKey = getImoveisListStatesStorageKey(storageHost, storageCodsite);
    const listDatasStorageKey = getImoveisListDatasStorageKey(storageHost, storageCodsite);
    const listCaracteristicasStorageKey = getImoveisListCaracteristicasStorageKey(storageHost, storageCodsite);

    const readLocalArray = (key: string) => {
        if (typeof window === 'undefined') return [];
        const value = readJsonStorageValue<any>(window.localStorage, key, []);
        return Array.isArray(value) ? value : [];
    };

    const withReadyDeliveryOption = (value: any) => {
        const options = Array.isArray(value) ? value.filter(Boolean) : [];
        const readyItem = { label: 'ImÃ³vel Pronto', value: 1 };
        const remaining = options.filter(
            (item: any) => !(item?.label === readyItem.label && item?.value === readyItem.value)
        );

        return [readyItem, ...remaining];
    };

    const newFilter = useCallback(() => {
        if (transacaoActual?.value) {
            if (transacaoActual.value.toLowerCase() === 'aluguel') {
                return valores?.precos_locacao[0];
            }
            if (transacaoActual.value.toLowerCase() === 'venda') {
                return valores?.precos_venda[0];
            }
            if (transacaoActual.value.toLowerCase() === 'temporada' && valores?.precos_locacao[0]) {
                return valores?.precos_locacao[0];
            }
        } else {
            if (allTransacao[0]?.value.toLowerCase() === 'aluguel') {
                return valores?.precos_locacao[0];
            }
            if (allTransacao[0]?.value.toLowerCase() === 'venda') {
                return valores?.precos_venda[0];
            }
            if (allTransacao[0].value.toLowerCase() === 'temporada' && valores?.precos_locacao[0]) {
                return valores?.precos_locacao[0];
            }
        }
        if(valores?.precos_venda[0]?.max > 0){
            return valores?.precos_venda[0];
        }else{
            return valores?.precos_locacao[0];
        }
    }, [allTransacao, transacaoActual, valores]);
    const getFiltersPricess = newFilter();
    const [filterPrice, setFilterPrice] = useState<any>(!getFiltersPricess?.min && !getFiltersPricess?.max ? { min: 0, max: 0 } : getFiltersPricess);
    const [value2, setValue2] = React.useState<number[]>([getFiltersPricess?.min , getFiltersPricess?.max]);
    const minDistance = Math.max(0, Math.min(500, Number(filterPrice?.max || 0) - Number(filterPrice?.min || 0)));

    const handleChange2 = (
        event: Event,
        newValue: number | number[],
        activeThumb: number,
      ) => {
        if (!Array.isArray(newValue)) {
          return;
        }

        const rangeMin = Number(filterPrice?.min || 0);
        const rangeMax = Number(filterPrice?.max || 0);

        if (newValue[1] - newValue[0] < minDistance) {
          if (activeThumb === 0) {
            const clamped = Math.max(rangeMin, Math.min(newValue[0], value2[1] - minDistance));
            setValue2([clamped, clamped + minDistance]);
          } else {
            const clamped = Math.min(rangeMax, Math.max(newValue[1], value2[0] + minDistance));
            setValue2([clamped - minDistance, clamped]);
          }
        } else {
          setValue2(newValue as number[]);
        }
        setBuscaAvan(true);
      };

    // methods
    const renderPath = () => {
        const transacao = (transacaoActual?.value || allTransacao[0]?.value || 'venda').toLowerCase();
        const cidade = citiesActual?.label?.replaceAll('-', '002D') || '-';
        const bairro = urlDistrict?.replaceAll('-', '002D') || '-';
        const empreendimento = companyActual?.label?.replaceAll('-', '002D') || '-';
        const tipo = urlTipo?.replaceAll('-', '002D') || '-';
        const codigo = codeActual ? `/${codeActual.replaceAll(' ', '%20')}` : '';

        const params = new URLSearchParams();
        const shouldUseAdvanced = buscaAvan || site?.id == 2297 || site?.id == 1942 || site?.id == 2065;
        const isEmptySite2551Search =
            Number(site?.id) === 2551 &&
            !codeActual &&
            !citiesActual?.label &&
            !urlDistrict &&
            !companyActual?.label &&
            !urlTipo &&
            !shouldUseAdvanced;

        if (shouldUseAdvanced) {
            if (estadoActual?.value) params.set('id_estado', String(estadoActual.value));
            params.set('min', String(value2?.[0] || 0));
            params.set('max', String(value2?.[1] || 0));
            if (urlDatas) params.set('data_entrega', String(urlDatas));
            if (showHomeCategoria && categoryActual?.value) params.set('categoria', String(categoryActual.value));
            if (showHomeDormitorios) params.set('dormitorios', String(dormitoriosActual?.value || 0));
            params.set('banheiros', String(banheirosActual?.value || 0));
            params.set('suites', String(suitesActual?.value || 0));
            params.set('vagas', String(vagasActual?.value || 0));
            if (showHomeCaracteristicas && urlCaract) params.set('id_caracteristica', String(urlCaract));
        }
        if (isEmptySite2551Search) {
            params.set('ordem', 'desc-inclusao');
        }

        let newPath = `/imoveis/${transacao}/${cidade}/${bairro}/${empreendimento}/${tipo}${codigo}`;
        if (params.toString()) {
            newPath = `${newPath}?${params.toString()}`;
        }

        newPath = appendCodsiteQuery(newPath, codsite2, origin);
        return removerAcentos(newPath).toLowerCase().replaceAll(' ', '-');
    };
    const onChangeCity = useCallback(async (txt: any) => {
        if (!txt) {
            setCitiesActual(null);
            setDistrictActual([]);
            setAllDistrict([]);
            return;
        }
        if (citiesActual?.value === txt?.value) return;
        setCitiesActual(txt);
        const infoDistrict = await district(txt.value, origin, codsite);
        setAllDistrict(formatSelects(infoDistrict?.bairros));
        setDistrictActual([])
    }, [citiesActual?.value, codsite, origin]);
    const onChangeDistrict = (txt: any) => {
        setUrlDistrict(txt?.map((tip: any) => {return tip?.label}).join("+"))
        setDistrictActual(txt);
    };
    const onChangeCompany = (txt: any) => {
        setCompanyActual(txt);
    };
    const onChangeTypes = (txt: any) => {
        setUrlTipo(txt?.map((tip: any) => {return tip?.label}).join("+"))
        setTypesActual(txt);
    };
    const onChangeCategory = (txt: any) => {
        if(categoryActual == txt)
            setCategoryActual([]);
        else
        setCategoryActual(txt);

        setBuscaAvan(true);
    };
    const onChangeEstado = async (txt: any) => {
        if(estadoActual == txt)
            setEstadoActual(null);
        else{
            // selecionou um novo estado
            setEstadoActual(txt);

            // filtra apenas as cidades que batem com o id_estado
            const cidadesFiltradas = allCities.filter(
                city => city?.id_estado === txt.value
            );

            setCitiesActual(null);
            setDistrictActual([])
            setAllCitiesAux(cidadesFiltradas);
        }
    };
    const onChangeDataEntrega = (txt: any) => {
        setUrlDatas(txt?.map((tip: any) => {return tip?.value}).join(","))
        setDataEntregaActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onChangeCaracteristicas = (txt: any) => {
        setUrlCaract(txt?.map((tip: any) => {return tip?.value}).join(","))
        setCaractActual(txt);
        if(txt?.length > 0)
            setBuscaAvan(true);
    };
    const onInputChangeCompany = (txt: any) => {
        setCompanyInputActual(txt);
    };
    const onChangeTransacao = (txt: any) => {
        setTransacaoActual(txt);
    };
    const onChangeDormitorios = (txt: any) => {
        setDormitoriosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeBanheiros = (txt: any) => {
        setBanheirosAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeSuites = (txt: any) => {
        setSuitesAtual(txt);
        setBuscaAvan(true);
    };
    const onChangeVagas = (txt: any) => {
        setVagasAtual(txt);
        setBuscaAvan(true);
    };

    const onChangeCode = (txt: React.ChangeEvent<HTMLInputElement>) => {
        setCodeActual(txt.target.value);
    };

    const GetInitialFilters = useCallback(async () => {
        if(listEstados === 0 && (site?.id == 2297 || site?.id == 1942 || site?.id == 2065)){
            const getCondo: any = readLocalArray(listStatesStorageKey);

            if(getCondo?.length > 0){
                setListEstados(getCondo);
            } else {
                const infoEstados = await get_estados(origin, codsite);
                const formatEstados = site?.id == 2065 ? formatSelectsEstados(infoEstados?.estados) : formatSelects(infoEstados?.estados);
                if(formatEstados?.length > 0){
                    localStorage.setItem(listStatesStorageKey, JSON.stringify(formatEstados));
                    setListEstados(formatEstados);
                }
                else
                setListEstados([]);
            }
        }

        if(listCategory === 0 && showHomeCategoria){
            const getCondo: any = readLocalArray(listCategoryStorageKey);

            if(getCondo?.length > 0){
                setListCategory(getCondo);
            } else {
                const infoCategory = await categorias(origin, codsite);
                const formatCategorias = formatSelects(infoCategory?.categorias);
                if(formatCategorias?.length > 0){
                    localStorage.setItem(listCategoryStorageKey, JSON.stringify(formatCategorias));
                    setListCategory(formatCategorias);
                }
                else
                    setListCategory([]);
            }
        }

        if(listCaracteristicas === 0 && showHomeCaracteristicas){
            const getCondo = getWithTTL<any>(listCaracteristicasStorageKey);

            if(getCondo?.length > 0){
                setListCaracteristicas(getCondo);
            } else {
                const infoCaracteristicas= await allCaracteristicas(origin, codsite);
                const formatCarac = formatCaracteristicas(infoCaracteristicas?.caracteristicas);
                if(formatCarac?.length > 0){
                    setListCaracteristicas(formatCarac);
                    const DAY_MS = 24 * 60 * 60 * 1000; // 86_400_000
                    setWithTTL(listCaracteristicasStorageKey, formatCarac, DAY_MS);
                }
                else
                setListCaracteristicas([]);
            }
        }

        if(listDatas === 0 && site?.mostrar_data_entrega){
            const getCondo: any = readLocalArray(listDatasStorageKey);

            if(getCondo?.length > 0){
                const newItem = { "label": "Imóvel Pronto", "value": 1 };

                // Adiciona o novo item no início do array
                getCondo.unshift(newItem);
                setListDatas(withReadyDeliveryOption(getCondo));
            } else {
                const infoDatas= await allDatasEntrega(origin, codsite);
                const formatDatas = Array.isArray(infoDatas?.datas_entrega)
                    ? withReadyDeliveryOption(formatSelectsTransacao(infoDatas.datas_entrega))
                    : [];

                if(formatDatas?.length > 0){
                    const newItem = { "label": "Imóvel Pronto", "value": 1 };

                    // Adiciona o novo item no início do array
                    void newItem;
                    setListDatas(formatDatas);
                    localStorage.setItem(listDatasStorageKey, JSON.stringify(formatDatas));
                }
                else
                setListDatas([]);
            }
        }
    }, [codsite, listCaracteristicas, listCaracteristicasStorageKey, listCategory, listCategoryStorageKey, listDatas, listDatasStorageKey, listEstados, listStatesStorageKey, origin, setListCaracteristicas, setListCategory, setListDatas, setListEstados, showHomeCaracteristicas, showHomeCategoria, site?.id, site?.mostrar_data_entrega]);

    const redirectToLink = useCallback(() => {
        const linkElement = document.getElementById("myLink");
        if (linkElement) {
          linkElement.click();
        }
    }, []);

    useEffect(() => {
        if((searchAdvanced || site?.id == 1684 || site?.id == 2146 || site?.id == 1803 || site?.id == 2297 || site?.id == 2065 || site?.id == 1942) && (showHomeCaracteristicas || showHomeCategoria || site?.mostrar_data_entrega)){
            GetInitialFilters()
        }
    }, [GetInitialFilters, searchAdvanced, showHomeCaracteristicas, showHomeCategoria, site?.id, site?.mostrar_data_entrega]);

    useEffect(() => {
    if (allCitiesAux?.length == 1 && Number(site?.id) !== 2523) {
        const onlyCity = allCitiesAux[0];
        if (citiesActual?.value !== onlyCity?.value) {
            onChangeCity(onlyCity);
        }
    }

    const handleKeyDown = (event: KeyboardEvent) => {
        if (event.key === "Enter") {
            redirectToLink();
        }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
        document.removeEventListener("keydown", handleKeyDown);
    };
}, [allCitiesAux, citiesActual?.value, onChangeCity, redirectToLink, site?.id]);

    useEffect(() => {
        const next = newFilter();
        if (!next) return;

        const boundsChanged = filterPrice?.min !== next.min || filterPrice?.max !== next.max;
        if (!boundsChanged) return;

        setFilterPrice(next);
        setValue2([next.min, next.max]);
    }, [filterPrice?.max, filterPrice?.min, newFilter]);

    // renders

    const renderArchives = () => {
        const mediaClassName = searchAdvanced ? styles.video_renderOn : styles.video_render;
        const fallbackMedia = bannerSrc ? (
            <Image
                className={`${mediaClassName} ${styles.media_fallback}`}
                alt="Banner"
                height={1200}
                width={600}
                sizes="100vw"
                src={bannerSrc}
                priority
            />
        ) : (
            <div
                className={`${mediaClassName} ${styles.media_fallback}`}
                aria-hidden="true"
            />
        );

        if (isMobileView && bannerSrc && site?.id != 1235) {
            return fallbackMedia;
        }

        if (!site?.url_video) {
            return fallbackMedia;
        }

        const videoSrc =
            isMobileView && site?.id == 1235
                ? site?.url_video.replace(".mp4","_b.mp4")
                : site?.url_video;

        return (
            <div className={styles.media_shell}>
                <video
                    autoPlay
                    muted
                    loop
                    height="100%"
                    width="100%"
                    className={`${mediaClassName} ${styles.media_overlay}`}
                    src={videoSrc}
                    playsInline
                    preload="auto"
                >
                    <track kind="captions" label="Legenda" src="legenda.vtt"></track>
                </video>
            </div>
        );
    };

    const GetOnlyCityCanoas = () => {
        const GetOnlyType = allCitiesAux.filter((e: any) => {
            return String(e.label)=="Canoas";
        })
        return GetOnlyType[0];
    };
    return (
        <div className={`${styles.welcomeHero} ${searchAdvanced ? styles.welcomeHeroAdvanced : ''}`}>
            <div className={styles.welcomeHeroMedia}>
                {renderArchives()}
            </div>
            <DrawerComponent
                site={site}
                activeDrawer={activeDrawer}
                setActiveDrawer={setActiveDrawer}
                favorito={favorito}
                menus={props?.menus}
            />
            <div className={`${styles.header_welcome} ${isSite2523 ? styles.header_welcome2523 : ''}`}>
                <div className={`${styles.body} ${isSite2523 ? styles.body2523 : ''}`}>
                    <div
                        className={`${styles.container_adjust_text_header} ${shouldHideHeaderText ? styles.container_adjust_text_headerHidden : ''} ${isSite2523 ? styles.container_adjust_text_header2523 : ''}`}
                        data-site-id={site?.id}
                        aria-hidden={shouldHideHeaderText}
                    >
                            <div className={`${styles.container_adjust_text_header} ${shouldHideHeaderText ? styles.container_adjust_text_headerHidden : ''} ${isSite2523 ? styles.container_adjust_text_header2523 : ''}`}>
                                <div className={`${styles.adjust_text_header} ${isSite2523 ? styles.adjust_text_header2523 : ''} ${shouldHideHeaderText ? styles.adjust_text_headerHidden : ''}`} style={isSite2523 && !use2523MobileDefaultLayout ? {textAlign: "left"} : {}}>
                                    {site?.frase_busca ?
                                    site?.id == '2112' ?
                                    <motion.h1
                                        alt="Título"
                                        className={`${styles.text_header} ${isSite2523 ? styles.text_header2523 : ''}`}
                                        style={{fontSize: '64px', margin: '0px'}}
                                        dangerouslySetInnerHTML={{
                                            __html: site?.frase_busca.toUpperCase(),
                                        }}
                                        initial={{ opacity: 0, y: 50 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{
                                            delay: 0.2,
                                            duration: 1,
                                            ease: "easeOut"
                                        }}
                                    ></motion.h1>
                                    :
                                    <motion.h1
                                        alt="Título"
                                         className={`${styles.text_header} ${isSite2523 ? styles.text_header2523 : ''}`}
                                        style={
                                        isSite2523 && !use2523MobileDefaultLayout
                                            ? {
                                                fontSize: '36px',
                                                marginBottom: '20px'
                                            }
                                            : site?.id == 2102 || site?.id == 2507
                                            ? { fontSize: 36 }
                                            : site?.id == 1992
                                            ? { fontSize: 38 }
                                            : site?.id == 2165 || site?.id == 1630
                                            ? { fontWeight: 500 }
                                            : site?.id == 1730
                                            ? { color: "#eacba6" }
                                            : site?.id == '2127'
                                            ? { margin: 0 }
                                            : site?.id == 2126
                                            ? { color: "#ab0303", fontSize: 40 }
                                            : {}
                                    }
                                        dangerouslySetInnerHTML={{
                                            __html: site?.frase_busca,
                                          }}
                                        initial={{ opacity: 0, y: 50 }}
                                        animate={{ opacity: 1, y: 0 }}
                                        transition={{
                                            delay: 0.2,
                                            duration: 1,
                                            ease: "easeOut"
                                        }}
                                    ></motion.h1>
                                    : null}
                                    {site?.frase_busca_2 ?
                                        <motion.h2
                                            alt="Subtitulo"
                                            initial={{ opacity: 0, y: 50 }}
                                            animate={{ opacity: 1, y: 0 }}
                                            transition={{
                                                delay: 0.4,
                                                duration: 1,
                                                ease: "easeOut"
                                            }}
                                            className={`${styles.text_header2} ${isSite2523 ? styles.text_header22523 : ''}`}
                                            style={
                                                isSite2523 && !use2523MobileDefaultLayout
                                                    ? {
                                                        fontSize: '26px'
                                                    }
                                                    : site?.id == "1832"
                                                    ? { display: "block" }
                                                    : site?.id == 1992 || site?.id == 2507
                                                    ? { fontSize: 25 }
                                                    : site?.id == '2103'
                                                    ? { fontSize: '24px', fontFamily: 'Roboto' }
                                                    : site?.id == '2127'
                                                    ? { fontSize: '26px' }
                                                    : site?.id == '2348'
                                                    ? { fontSize: '24px' }
                                                    : {}
                                            }>
                                            {site?.frase_busca_2}
                                        </motion.h2>
                                    : null}
                                </div>
                            </div>
                        </div>
                    <div
                        className={isSite2523 ? styles.searchCardWrapper2523 : ''}
                        style={isSite2523 && !use2523MobileDefaultLayout ? {justifyContent: "flex-start", display: "block", width: "100%",maxWidth: "1300px"} : {justifyContent: "center", display: "block", width: "100%"}}
                    >
                        { site?.id != "1999" ?
                            <motion.div
                                alt="Filtros"
                                className={`${site?.id == "2057" ? styles.adjust_selects2 : styles.adjust_selects} ${isSite2523 ? styles.adjust_selects2523 : ''}`}
                                style={
                                    site?.id == "1937"
                                        ? { background: "none" }
                                        : isSite2523 && !use2523MobileDefaultLayout
                                        ? { background: "transparent" }
                                        : { background: `${site?.cor12 + 50}` }
                                }
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                    delay: 0.6,
                                    duration: 1,
                                    ease: "easeOut"
                                }}
                            >
                                <div className={`${styles.column} ${isSite2507 ? styles.column2507 : ''} ${isSite2504 ? styles.columnOnlyButton2504 : ''} ${site?.id == "2274" ? styles.column2274 : ''}`}>
                                    { site?.id != "1937" ? <>
                                        <div className={site?.id == "2297" || site?.id == 1942 || site?.id == 2065 ? styles.menu3 : site?.transacoes?.length > 1 ? styles.menu : styles.advancedOff} style={site?.id == "1819" ? {width: "33%"} : primarySearchFieldStyle2507}>
                                           <label htmlFor="home1-transacao" className={styles.visually_hidden}>
                                                {Number(site?.id) === 2523 ? "Tipo de Negócio" : "Escolha a Transação:"}
                                            </label>

                                            <Select
                                                inputId="home1-transacao"
                                                aria-label={Number(site?.id) === 2523 ? "Tipo de Negócio" : "Transação"}
                                                defaultValue={site?.id == 2470 || Number(site?.id) === 2523 ? null : allTransacao[0]}
                                                options={allTransacao}
                                                className={styles.select}
                                                placeholder={
                                                    Number(site?.id) === 2523
                                                        ? "Tipo de Negócio"
                                                        : site?.id == 2470
                                                        ? "Finalidade"
                                                        : allTransacao?.length > 0
                                                        ? allTransacao[0]?.value
                                                        : "Transação"
                                                }
                                                noOptionsMessage={() => 'Processando'}
                                                styles={colorPicker}
                                                value={transacaoActual}
                                                onChange={onChangeTransacao}
                                                instanceId={1}
                                                isSearchable={false}
                                            />
                                        </div>
                                        {(site?.id == "1684" || site?.id == "2146" || site?.id == "1803") && showHomeCategoria && listCategory?.length > 0 &&
                                        <div className={styles.menu}>
                                            <label htmlFor="react-select-2-input" className={styles.visually_hidden}>Categoria:</label>
                                            <Select
                                                options={listCategory}
                                                className={styles.select}
                                                placeholder="Categoria"
                                                noOptionsMessage={() =>
                                                    'Categoria não encontrada'
                                                }
                                                styles={colorPicker}
                                                onChange={onChangeCategory}
                                                value={categoryActual}
                                                instanceId={3}
                                                isSearchable={isMobile || isMobile1 ? false : true}
                                            />
                                        </div>}
                                        <div className={site?.id == "2297" || site?.id == 1942 || site?.id == 2065 ? styles.menu3 : site?.id == "2297" || site?.id == 2065 ? styles.menu3 : site?.transacoes?.length > 1 || site?.id == "2148" || site?.id == "2480" || site?.id == "1684" || site?.id == "1955" || site?.id == "1961" || site?.id == "2351" || site?.id == "2297" || site?.id == 2065 || site?.id == "1630" || site?.id == "604" || site?.id == "2387" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1} style={site?.id == "1819" ? {width: "33%"} : primarySearchFieldStyle2507}>
                                            <label htmlFor="home1-tipo-imovel" className={styles.visually_hidden}>Escolha o Tipo:</label>
                                            <Select
                                                inputId="home1-tipo-imovel"
                                                aria-label="Tipo de imóvel"
                                                options={allTypes}
                                                className={styles.select}
                                                isMulti
                                                placeholder={urlTipo ? typesActual?.length + " Selecionado (s)" : "Tipo de imóvel"}
                                                styles={colorPicker}
                                                closeMenuOnSelect={site?.id == "2091" ? true : false}
                                                controlShouldRenderValue={false}
                                                noOptionsMessage={() =>
                                                    'Tipo não encontrado'
                                                }
                                                hideSelectedOptions={false}
                                                tabSelectsValue={false}
                                                value={typesActual}
                                                onChange={onChangeTypes}
                                                closeMenuOnScroll={true}
                                                isSearchable={isMobile || isMobile1 ? false : true}
                                                instanceId={2}
                                            />
                                        </div>
                                        {(site?.id == 2297 || site?.id == 1942 || site?.id == 2065) && listEstados &&
                                            <div className={styles.menu3}>
                                                <label htmlFor="react-select-2-input" className={styles.visually_hidden}>Estado:</label>
                                                <Select
                                                    options={listEstados}
                                                    className={styles.select}
                                                    placeholder="Estado"
                                                    noOptionsMessage={() =>
                                                        'Estado não encontrado'
                                                    }
                                                    styles={colorPicker}
                                                    onChange={onChangeEstado}
                                                    value={estadoActual}
                                                    instanceId={113}
                                                    isSearchable={isMobile || isMobile1 ? false : true}
                                                />
                                            </div>}

                                        {site?.id == "1819" || site?.id == "2507" ?
                                            site?.id == "2507" ?
                                                <div className={site?.transacoes?.length > 1 ? styles.menu : styles.menu1} style={primarySearchFieldStyle2507}>
                                                    <label htmlFor="home1-bairro" className={styles.visually_hidden}>Escolha o Bairro:</label>
                                                    <Select
                                                        inputId="home1-bairro"
                                                        aria-label="Bairro"
                                                        options={allDistrict}
                                                        className={styles.select}
                                                        placeholder={urlDistrict ? districtActual?.length + " Selecionado (s)" : "Bairro"}
                                                        closeMenuOnSelect={site?.id == "2091" ? true : false}
                                                        controlShouldRenderValue={false}
                                                        hideSelectedOptions={false}
                                                        tabSelectsValue={false}
                                                        noOptionsMessage={() =>
                                                            citiesActual ? 'Bairro não encontrado' : 'Selecione uma cidade'
                                                        }
                                                        isMulti
                                                        styles={colorPicker}
                                                        value={districtActual}
                                                        onChange={onChangeDistrict}
                                                        isSearchable={isMobile || isMobile1 ? false : true}
                                                        instanceId={4}
                                                    />
                                                </div>
                                            : null
                                        :<>
                                            <div className={site?.id == "2297" || site?.id == 1942 || site?.id == 2065 ? styles.menu3 : site?.transacoes?.length > 1 || site?.id == "2148" || site?.id == "2480" || site?.id == "1684" || site?.id == "2297" || site?.id == 2065 || site?.id == "1630" || site?.id == "1955" || site?.id == "1961" || site?.id == "2351" || site?.id == "604" || site?.id == "2387" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1}>
                                                <label htmlFor="home1-cidade" className={styles.visually_hidden}>Escolha a Cidade:</label>
                                                <Select
                                                    inputId="home1-cidade"
                                                    aria-label="Cidade"
                                                    options={allCitiesAux}
                                                    className={styles.select}
                                                    placeholder="Cidade"
                                                    noOptionsMessage={() => 'Cidade não encontrada'}
                                                    styles={colorPicker}
                                                    onChange={onChangeCity}
                                                    value={Number(site?.id) === 2523 ? null : (!citiesActual && site?.id == "1772" ? GetOnlyCityCanoas() : citiesActual)}
                                                    instanceId={3}
                                                    isSearchable={isMobile || isMobile1 ? false : true}
                                                />
                                            </div>
                                            <div className={site?.id == "2297" || site?.id == 1942 || site?.id == 2065 ? styles.menu3 : site?.transacoes?.length > 1 || site?.id == "2148" || site?.id == "2480" || site?.id == "1684" || site?.id == 2065 || site?.id == "2297" || site?.id == "1961" || site?.id == "1955" || site?.id == "2351" || site?.id == "1630" || site?.id == "604" || site?.id == "2387"  || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1}>
                                                <label htmlFor="home1-bairro" className={styles.visually_hidden}>Escolha o Bairro:</label>
                                                <Select
                                                    inputId="home1-bairro"
                                                    aria-label="Bairro"
                                                    options={allDistrict}
                                                    className={styles.select}
                                                    placeholder={urlDistrict ? districtActual?.length + " Selecionado (s)" : "Bairro"}
                                                    closeMenuOnSelect={site?.id == "2091" ? true : false}
                                                    controlShouldRenderValue={false}
                                                    hideSelectedOptions={false}
                                                    tabSelectsValue={false}
                                                    noOptionsMessage={() =>
                                                        citiesActual ? 'Bairro não encontrado' : 'Selecione uma cidade'
                                                    }
                                                    isMulti
                                                    styles={colorPicker}
                                                    value={districtActual}
                                                    onChange={onChangeDistrict}
                                                    isSearchable={isMobile || isMobile1 ? false : true}
                                                    instanceId={4}
                                                />
                                            </div>
                                            { site?.id == "2480" || site?.id == "2148" || site?.id == "604" || site?.id == "2387"  || site?.id == "1955" || site?.id == "2351" || site?.id == "1630" || site?.id == "1961" || site?.id == "2274" ?
                                                <div className={site?.id == "2297" || site?.id == 1942 || site?.id == 2065 ? styles.menu3 : site?.transacoes?.length > 1 || site?.id == "2148" || site?.id == "2480" || site?.id == "2351" || site?.id == "1961" || site?.id == "1684" || site?.id == "1630" || site?.id == "604" || site?.id == "2387" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1}>
                                                    <label htmlFor="react-select-9-input" className={styles.visually_hidden}>Empreendimento:</label>
                                                    <Select
                                                        options={allCompany}
                                                        className={styles.select1}
                                                        placeholder={
                                                        site?.id == 1892
                                                            ? "Residenciais e loteamentos"
                                                            : site?.id == 2374
                                                            ? "Condomínio/Loteamento"
                                                            : "Condomínios"
                                                        }
                                                        styles={colorPicker}
                                                        value={companyActual}
                                                        inputValue={companyInputActual}
                                                        noOptionsMessage={() =>
                                                            allCompany?.length > 1 ? 'Condomínio não encontrado' : 'Digite o nome do condomínio'
                                                        }
                                                        instanceId={9}
                                                        onChange={onChangeCompany}
                                                        onInputChange={onInputChangeCompany}
                                                    />
                                                </div>
                                            : null }
                                        </>}

                                        {site?.id != "2274" ? (
                                            <div className={site?.id == "2297" || site?.id == 1942 || site?.id == 2065 ? styles.menu3 : site?.transacoes?.length > 1 || site?.id == "2148" || site?.id == "2480" || site?.id == "1684" || site?.id == "1955" || site?.id == "1961" || site?.id == "2351" || site?.id == "2118" || site?.id == 2065 || site?.id == "2297" || site?.id == "1630" || site?.id == "604" || site?.id == "2387" || site?.id == "2146" || site?.id == "1803" ? styles.menu : styles.menu1} style={site?.id == "1819" ? {width: "33%"} : primarySearchFieldStyle2507}>
                                                <label htmlFor="codigoDoImovel" className={styles.visually_hidden}>Escolha a Referência:</label>
                                                <input
                                                    className={styles.input}
                                                    placeholder=" Código"
                                                    value={codeActual}
                                                    onChange={onChangeCode}
                                                    id="codigoDoImovel"
                                                    type="text"
                                                />
                                            </div>
                                        ) : null}
                                        <div className={searchAdvanced ? styles.advanced : styles.advancedOff}>
                                            {(site?.id != "1684" && site?.id != "2146" && site?.id != "1803") && showHomeCategoria && listCategory?.length > 0 &&
                                            <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2}>
                                                <label htmlFor="react-select-11-input" className={styles.visually_hidden}>Categoria:</label>
                                                <Select
                                                    options={listCategory}
                                                    className={styles.select}
                                                    placeholder="Categoria"
                                                    noOptionsMessage={() =>
                                                        'Categoria não encontrada'
                                                    }
                                                    styles={colorPicker}
                                                    onChange={onChangeCategory}
                                                    value={categoryActual}
                                                    instanceId={3}
                                                    isSearchable={isMobile || isMobile1 ? false : true}
                                                />
                                            </div>}
                                            {(site?.id != "1684" && site?.id != "2146" && site?.id != "1803") && showHomeCaracteristicas && listCaracteristicas?.length > 0 &&
                                            <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2}>
                                                <label htmlFor="react-select-11-input" className={styles.visually_hidden}>Características:</label>
                                                <Select
                                                    options={listCaracteristicas}
                                                    className={styles.select}
                                                    isMulti
                                                    placeholder={urlCaract ? caractActual?.length + " Selecionada (s)" : "Características"}
                                                    noOptionsMessage={() =>
                                                        'Característica não encontrada'
                                                    }
                                                    styles={colorPicker}
                                                    closeMenuOnSelect={false}
                                                    controlShouldRenderValue={false}
                                                    hideSelectedOptions={false}
                                                    tabSelectsValue={false}
                                                    onChange={onChangeCaracteristicas}
                                                    value={caractActual}
                                                    closeMenuOnScroll={false}
                                                    instanceId={12}
                                                    isSearchable={isMobile || isMobile1 ? false : true}
                                                />
                                            </div>}
                                            {site?.mostrar_data_entrega && listDatas?.length > 0 &&
                                                <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2}>
                                                    <label htmlFor="react-select-111-input" className={styles.visually_hidden}>Data Entrega:</label>
                                                        <Select
                                                            options={listDatas}
                                                            className={styles.select}
                                                            isMulti
                                                            placeholder={urlDatas ? dataEntregaActual?.length + " Selecionada (s)" : "Datas de entrega"}
                                                            noOptionsMessage={() =>
                                                                'Data de entrega não encontrada'
                                                            }
                                                            styles={colorPicker}
                                                            closeMenuOnSelect={false}
                                                            controlShouldRenderValue={false}
                                                            hideSelectedOptions={false}
                                                            tabSelectsValue={false}
                                                            onChange={onChangeDataEntrega}
                                                            value={dataEntregaActual}
                                                            closeMenuOnScroll={false}
                                                            instanceId={12}
                                                            isSearchable={isMobile || isMobile1 ? false : true}
                                                        />
                                                </div>
                                            }
                                            <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2} style={advancedFirstFieldStyle2507}>
                                                <label htmlFor="react-select-6-input" className={styles.visually_hidden}>Banheiros:</label>
                                                <Select
                                                    options={allOptions}
                                                    className={styles.select}
                                                    placeholder={banheirosActual?.value == 1 ? "1 Banheiro" : (banheirosActual?.label || "") + " Banheiros"}
                                                    styles={colorPicker}
                                                    value={banheirosActual}
                                                    onChange={onChangeBanheiros}
                                                    isSearchable={false}
                                                    instanceId={6}
                                                    controlShouldRenderValue={false}
                                                />
                                            </div>
                                            <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2} style={advancedFieldStyle2507}>
                                                <label htmlFor="react-select-5-input" className={styles.visually_hidden}>Quartos:</label>
                                                <Select
                                                    options={allOptions}
                                                    className={styles.select}
                                                    placeholder={dormitoriosActual?.value == 1 ? "1 Quarto" : (dormitoriosActual?.label || "") + " Quartos"}
                                                    styles={colorPicker}
                                                    value={dormitoriosActual}
                                                    onChange={onChangeDormitorios}
                                                    isSearchable={false}
                                                    instanceId={5}
                                                    controlShouldRenderValue={false}
                                                />
                                            </div>
                                            {site?.id != "2507" ?
                                                <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2} style={advancedFieldStyle2507}>
                                                    <label htmlFor="react-select-7-input" className={styles.visually_hidden}>Suítes:</label>
                                                    <Select
                                                        options={allOptions}
                                                        className={styles.select}
                                                        placeholder={suitesActual?.value == 1 ? "1 Suíte" : (suitesActual?.label || "") + " Suítes"}
                                                        styles={colorPicker}
                                                        value={suitesActual}
                                                        onChange={onChangeSuites}
                                                        instanceId={7}
                                                        isSearchable={false}
                                                        controlShouldRenderValue={false}
                                                    />
                                                </div>
                                            : null }
                                            <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.menu2} style={advancedFieldStyle2507}>
                                                <label htmlFor="react-select-8-input" className={styles.visually_hidden}>Vagas:</label>
                                                <Select
                                                    options={allOptions}
                                                    className={styles.select}
                                                    placeholder={vagasActual?.value == 1 ? "1 Vaga" : (vagasActual?.label || "") + " Vagas"}
                                                    styles={colorPicker}
                                                    value={vagasActual}
                                                    onChange={onChangeVagas}
                                                    instanceId={8}
                                                    isSearchable={false}
                                                    controlShouldRenderValue={false}
                                                />
                                            </div>
                                            { site?.exibir_empreendimento && site?.id != "604" && site?.id != "2148"  && site?.id != "2387" && site?.id != "1630" && site?.id != "1961" && site?.id != "1955" && site?.id != "2351" ?
                                                <div className={site?.id == "2297" || site?.id == 2065 ? styles.menu3 : styles.pricefilter}>
                                                    <label htmlFor="react-select-9-input" className={styles.visually_hidden}>Empreendimento:</label>
                                                    <Select
                                                        options={allCompany}
                                                        className={styles.select1}
                                                        placeholder={
                                                        site?.id == "1892"
                                                            ? "Residenciais e loteamentos"
                                                            : site?.id == 2374
                                                            ? "Condomínio/Loteamento"
                                                            : "Condomínios"
                                                        }
                                                        styles={colorPicker}
                                                        value={companyActual}
                                                        inputValue={companyInputActual}
                                                        noOptionsMessage={() =>
                                                            allCompany?.length > 1 ? 'Condomínio não encontrado' : 'Digite o nome do condomínio'
                                                        }
                                                        instanceId={9}
                                                        onChange={onChangeCompany}
                                                        onInputChange={onInputChangeCompany}
                                                    />
                                                </div>
                                            : null }
                                            <div className={styles.pricefilter} style={{padding: "0px 0px 0px 5%"}}>
                                                <div className={styles.adjust_select_price}>
                                                    <div className={styles.title_select}>
                                                        PREÇOS
                                                    </div>
                                                    <div className={styles.adjust_prices}>
                                                        <div className={styles.price}>
                                                            {`${site?.moeda_tipo} ${toPrice(Number(value2[0]),2
                                                            )}`}
                                                        </div>
                                                        <div className={styles.price}>
                                                            {`${site?.moeda_tipo} ${toPrice(
                                                                Number(value2[1]),2
                                                            )}`}
                                                        </div>
                                                    </div>
                                                    <Slider
                                                        getAriaLabel={() => 'Minimum distance shift'}
                                                        value={value2}
                                                        onChange={handleChange2}
                                                        valueLabelDisplay="auto"
                                                        min={filterPrice?.min}
                                                        max={filterPrice?.max}
                                                        step={transacaoActual?.value == "Aluguel" ? 100 : 10000}
                                                        style={{
                                                            color: `${'rgb(255, 255, 255)'}`,
                                                        }}
                                                        getAriaValueText={valuetext}
                                                        disableSwap
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </> : null}
                                    <div className={styles.menuBottom}>
                                        <Link
                                            href={site?.id != "1937" ? renderPath() : `https://api.whatsapp.com/send?phone=${(
                                            site?.Dados?.tel1 ||
                                            site?.Dados?.tel2 ||
                                            site?.Dados?.tel3 ||
                                            site?.Dados?.tel4
                                            )?.replace(/\D/g, '')}&text=Olá, estou no site da ${site?.titulo} Visitando a página https://${site?.site} pode me ajudar?`}
                                            id="myLink"
                                            title={`Buscar ${typesActual[0] ? typesActual[0]?.label : 'imóveis'}${districtActual[0] ? ' em '+ districtActual[0]?.label : ''}${citiesActual?.label ? ' - '+ citiesActual?.label : ''}${codeActual ? ' - Imóvel código: '+ codeActual : ''}`}
                                            className={site?.id == "1937" ? styles.btn_leila : styles.btn}
                                            style={site?.id == 2231 ?
                                                {
                                                    background: searchButtonBackground,
                                                    border: `1px solid ${site?.cor2 || '#FFFFFF'}`,
                                                    color: searchButtonTextColor,
                                                    borderRadius: 10
                                                }
                                                : {
                                                background: searchButtonBackground,
                                                border: `1px solid ${site?.cor2 || '#FFFFFF'}`,
                                                color: searchButtonTextColor,
                                                }}
                                            >
                                            {site?.id != "1937" ? "Buscar" : "Fale com a Leila"}
                                        </Link>
                                    </div>
                                </div>
                            </motion.div>
                        : null }
                            <motion.div
                                alt="Avançado"
                                className={`${styles.buttonAdvanced} ${isSite2504 ? styles.buttonAdvanced2504 : ''}`}
                                style={site?.id == 2523 ? {placeSelf: "center"} : {}}
                                initial={{ opacity: 0, y: 50 }}
                                animate={{ opacity: 1, y: 0 }}
                                transition={{
                                    delay: 0.8,
                                    duration: 1,
                                    ease: "easeOut"
                                }}
                            >
                            {site?.id != "1937" && site?.id != "1999" ?
                                searchAdvanced ?
                                    <div onClick={() => setSearchAdvanced(0)}>
                                        <svg width="16" height="16" fill="white" viewBox="0 0 16 16">
                                            <path d="M7.646 4.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1-.708.708L8 5.707l-5.646 5.647a.5.5 0 0 1-.708-.708l6-6z"/>
                                        </svg>
                                        <i style={{margin: "5px"}}>
                                            Simples
                                        </i>
                                    </div> :
                                    <div onClick={() => setSearchAdvanced(1)}>
                                        <svg
                                            viewBox="0 0 18 18"
                                            height="1rem"
                                            width="1rem"
                                            aria-hidden="true"
                                            style={{ fill: 'white' }}
                                        >
                                            <path fill="none" d="M0 0h24v24H0V0z"></path>
                                            <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z"></path>
                                        </svg>
                                        <i style={{margin: "5px"}}>
                                            Avançado
                                        </i>

                                    </div>
                            : null}
                        </motion.div>
                    </div>

                    { allCards?.length > 0 ?
                        <motion.ul
                            alt="Busca rápida"
                            className={styles.allCards}
                            initial={{ opacity: 0, y: 50 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{
                                delay: 1,
                                duration: 1,
                                ease: "easeOut"
                            }}
                        >
                            {allCards.map((card: any, index: number) => {
                                return (
                                    <li className={styles.allCardsLi} key={index}>
                                        <Link prefetch={false} href={removerAcentos(card?.url).toLowerCase()} passHref>
                                            <div className={styles.card_busca} title={`Busca personalizada por imóvies: ${card?.nome}`}>{card?.nome}</div>
                                        </Link>
                                    </li>
                                );
                            })}
                        </motion.ul>
                    : null }
                </div>
            </div>
        </div>
    );
};

export default WelcomePieces;
